import {baseNewImagesPath} from "../../assets";
import {IS_LIXIL_UI} from "../../../config";
import styleHelpers from "./styles/printDocumentStylesHelpers";
import printDocumentStylesDiscounts from "./styles/printDocumentStylesDiscounts";
import printDocumentStylesHomeDepot from "./styles/printDocumentStylesHomeDepot";

export const registerFonts = () => {
  const {Font} = window.ReactPdfRenderer;
  try {
    Font.register({
      family: "Play",
      src: `${baseNewImagesPath}fonts/play-regular.ttf`
    });
    Font.register({
      family: "PlayBold",
      src: `${baseNewImagesPath}fonts/play-bold.ttf`
    });
    Font.register({
      family: "FrutigerLTStd-Light",
      src: `${baseNewImagesPath}fonts/frutiger/FrutigerLTStd-Light.ttf`
    });
    Font.register({
      family: "Frutiger-Roman",
      src: `${baseNewImagesPath}fonts/frutiger/Frutiger-Roman.ttf`
    });
    Font.register({
      family: "Roboto",
      src: `${baseNewImagesPath}fonts/Roboto/Roboto-Regular.ttf`
    });
    Font.register({
      family: "Roboto500",
      src: `${baseNewImagesPath}fonts/Roboto/Roboto-Medium.ttf`
    });
  } catch (error) {
    console.log("error registering fonts", error);
  }
}

export default function getPrintColors(activeTheme) {

  const COLORS = {
    black: "#000000",
    red: "#d0021b",
    gray: "#828282",
    gray2: "#7e7e7e",
    gray3: "#9f9f9f",
    gray4: "#979797",
    light: "#c8c8c8",
    light2:"#d8d8d8",
    white: "#ffffff",
  };

  switch (activeTheme) {
    case "qc":
    default: {
      COLORS.green = IS_LIXIL_UI ? "#000000" : "#9FC522";
      COLORS.blue = IS_LIXIL_UI ? "#000000" : "#4a90e2";
      COLORS.lightBlue = "#98C3FA";
      COLORS.regular = IS_LIXIL_UI ? "Roboto" : "Play";
      COLORS.bold = IS_LIXIL_UI ? "Roboto500" : "PlayBold";
      COLORS.black = "#000000";
      break;
    }
    case "caes": {
      COLORS.green = "#f46c42";
      COLORS.blue = "#58595b";
      COLORS.lightBlue = "#717275"; // lighten primary 10%
      COLORS.regular = "FrutigerLTStd-Light";
      COLORS.bold = "Frutiger-Roman";
      COLORS.black = "#000000";
      break;
    }
    case "moderno": {
      COLORS.green = "#d0021b";
      COLORS.blue = "#1b1b1b";
      COLORS.lightBlue = "#444444"; // lighten primary 10%
      COLORS.regular = "Play";
      COLORS.bold = "PlayBold";
      COLORS.black = "#000000";
      break;
    }
    case "as": {
      COLORS.green = "#E70026";
      COLORS.blue = "#000000";
      COLORS.lightBlue = "#292929"; // lighten primary 10%
      COLORS.regular = "Play";
      COLORS.bold = "PlayBold";
      COLORS.black = "#000000";
      break;
    }
  }

  return getStyles(COLORS)

}

const getStyles = (COLORS) => window.ReactPdfRenderer.StyleSheet.create({
  ...styleHelpers,
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontFamily: COLORS.regular,
    color: COLORS.gray,
    fontSize: 10,
  },
  pageAS: {
    paddingTop: 100,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontFamily: COLORS.regular,
    color: COLORS.gray,
    fontSize: 10,
  },
  bold: {
    fontFamily: COLORS.bold,
  },
  black: {
    color: COLORS.black,
  },
  gray: {
    color: COLORS.gray,
  },
  primary: {
    color: COLORS.blue,
  },
  active: {
    color: COLORS.green,
  },
  red: {
    color: COLORS.red,
  },
  header: {
    // borderColor: "#fff000",
    // borderStyle: "solid",
    // borderWidth: 2,
    maxHeight: 60,
    minHeight: 40,
    marginBottom: 25,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  headerInfo: {
    // textAlign: "right",
  },
  headerLogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 3,
    flex: 1,
  },
  headerLogoAS: {
    marginTop: -35,
    paddingLeft: 70,
    paddingRight: 70,
  },
  headerLogoImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    alignSelf: "center",
    objectFit : "contain",
  },
  headerText: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end"
  },
  headerTextBold: {
    fontFamily: COLORS.bold,
  },
  specSheet: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    paddingTop: 35,
    paddingHorizontal: 35,
    height: 100,
    // width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerTextASSheet: {
    width: "20%",
    flex: "0 0 20%",
    fontSize: 15,
    color: COLORS.gray3,
  },
  headerTextASInfo: {
    width: "20%",
    flex: "0 0 20%",
  },
  headerTextValue: {
    paddingLeft: 5,
    // width: 50,
    // textAlign: "right",
  },
  main: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  section: {
    width: "33%",
    flex: "0 0 33%"
  },
  sectionTwo: {
    width: "45%",
    flex: "0 0 45%"
  },
  sectionLeft: {
    paddingRight: 10
  },
  sectionCenter: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  sectionRight: {
    paddingLeft: 10
  },
  mainTitle: {
    fontFamily: COLORS.bold,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.gray2,
    paddingBottom: 3,
    marginBottom: 5,
  },
  mainTitle2: {
    fontFamily: COLORS.bold,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.gray2,
    borderTopColor: COLORS.gray2,
    paddingTop: 5,
    paddingBottom: 5,
  },
  mainTitle2Inner: {
    height: 14,
  },
  mainText: {
    marginBottom: 2,
  },
  mainTextEmail: {
    marginTop: 10,
  },
  room: {
    borderLeftColor: COLORS.light,
    borderLeftWidth: 1,
    borderLeftStyle: "solid",
    marginTop: 30,
    borderBottomColor: COLORS.light,
    borderBottomWidth: 1,
  },
  roomTitle: {
    color: COLORS.gray2,
    padding: 5,
    backgroundColor: COLORS.light,
    fontSize: 11,
    textTransform: "uppercase",
    fontFamily: COLORS.bold,
  },
  roomBody: {
    paddingLeft: 20
  },
  subPartTitle: {
    color: COLORS.blue,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.blue,
    padding: 2,
    marginRight: 2,
    marginBottom: 10,
    marginTop: 10,
    marginLeft: -10
  },
  cartItem: {
    borderBottomWidth: 1,
    borderBottomColor: COLORS.light,
    paddingBottom: 2,
    marginBottom: 5,
  },
  cartItemSubGroupTitle: {
    backgroundColor: COLORS.light2,
    color: COLORS.gray4,
    paddingHorizontal: 5,
    paddingVertical: 3,
    marginBottom: 3,
    marginLeft: -5,
  },
  cartItemWithThumbnail: {
    flexDirection: "row",
    paddingBottom: 5,
  },
  cartItemWithThumbnailBody: {
    flex: 1,
    overflow: "hidden",
  },
  cartItemThumbnail: {
    borderWidth: 1,
    borderColor: COLORS.light,
    borderRadius: 5,
    padding: 8,
    marginRight: 5,
    width: 64,
    height: 64,
    flexBasis: 64,
  },
  cartItemThumbnailImage: {
    width: 48,
    height: 48,
    flexBasis: 48,
    objectFit: "contain",
  },
  cartItemSkuFullWidth: {
    flex: 1,
    color: COLORS.gray,
    fontSize: 9,
    marginBottom: 10,
  },
  cartItemDescription: {
    marginTop: 4,
    marginBottom: 4,
  },
  cartItemName: {
    fontFamily: COLORS.bold,
    color: COLORS.gray,
  },
  cartItemNameBig: {
    fontSize: 11,
  },
  cartItemNameCentered: {
    marginTop: 10,
  },
  cartItemInfo: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignSelf: "stretch",
    width: "100%",
    color: COLORS.gray,
    marginTop: 5,
  },
  cartItemUnit: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 40,
    width: 40,
    color: COLORS.gray,
    fontSize: 9,
  },
  wizardItemDescription: {
    flexGrow: 1,
    flexShrink: 1,
    color: COLORS.gray,
    fontSize: 9,
  },
  cartItemUnitSKU: {
    flexBasis: 80,
    width: 80,
  },
  cartItemUnitItem: {},
  cartItemPrice: {
    flexGrow: 5,
    flexShrink: 5,
    flexBasis: 100,
    width: 100,
    justifyContent: "flex-end",
    alignSelf: "flex-end",
    textAlign: "right",
    fontFamily: COLORS.bold,
  },
  cartItemNote: {
    marginTop: 3,
    marginBottom: 3,
    padding: 5,
    borderColor: COLORS.light,
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 5,
    color: COLORS.blue
  },
  cartItemSimilar: {
    width: "100%",
    marginTop: 10,
    // marginBottom: 10,
    // paddingLeft: 10,
  },
  cartItemSimilarTitle: {
    padding: 5,
    color: COLORS.white,
    backgroundColor: COLORS.lightBlue,
    fontSize: 10,
    marginBottom: 10,
  },
  cartItemSimilarTitleBundled: {
    marginBottom: 5,
  },
  cartItemBundled: {
    marginBottom: 10,
  },
  cartItemSimilarTitlePadding: {
    marginLeft: 10
  },
  cartItemSimilarContent: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  cartItemSimilarContentCell: {
    width: "50%",
    flex: "0 0 50%"
  },
  cartItemSimilarItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "stretch",
    width: "100%",
    borderBottomWidth: 1,
    borderBottomStyle: "dashed",
    borderBottomColor: COLORS.light,
    paddingBottom: 2,
    marginBottom: 5,
    // alignItems: "center", places price to center
  },
  cartItemSimilarItemNoBorder: {
    borderBottomWidth: 0,
  },
  cartItemSimilarItemBlock: {
  },
  cartItemSimilarItemName: {
    color: COLORS.blue,
    fontSize: 10,
  },
  cartItemSimilarItemLabel: {
    textTransform: "uppercase",
    fontFamily: COLORS.bold,
    color: COLORS.gray2,
    fontSize: 8,
  },
  cartItemSimilarItemPrice: {
    fontSize: 12,
    color: COLORS.blue
  },
  cartItemSimilarItemExample: {
    fontSize: 8,
    color: COLORS.gray
  },
  roomTotal: {
    marginVertical: 10,
    textAlign: "right",
  },
  roomTotalSecond: {
    marginTop: 0,
    marginBottom: 10,
    textAlign: "right",
  },
  roomTotalText: {
    fontFamily: COLORS.bold,
  },
  roomTotalAmount: {
    fontSize: 12,
    marginLeft: 4,
    color: COLORS.blue,
  },
  roomTotalMultiplier: {
    marginTop: -7.5,
  },
  footer: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-around",
    alignSelf: "stretch",
    width: "100%",
  },
  footerLeft: {
    flexGrow: 1,
    flexShrink: 1,
    textAlign: "center"
  },
  notification: {
    padding: 20,
    borderColor: COLORS.red,
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 5,
  },
  notificationMargin: {
    marginTop: 20,
  },
  notificationImage: {
    width: 25,
    height: 21,
    marginTop: -5,
    marginBottom: 10,
    marginHorizontal: "auto"
  },
  notificationText: {
    width: "66.5%",
  },
  total: {
    flexBasis: 160,
    textAlign: "right",
  },
  totalSectionFirst: {
    textAlign: "right",
  },
  totalSection: {
    marginTop: 15,
    textAlign: "right",
  },
  totalSectionText: {
    fontFamily: COLORS.bold,
  },
  totalSectionAmount: {
    fontSize: 14,
    color: COLORS.blue,
  },
  totalSectionFinal: {
    marginTop: 30,
    textAlign: "right",
  },
  totalSectionAmountFinal: {
    fontSize: 22,
    color: COLORS.green,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 13,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: COLORS.gray,
  },
  signature: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: 30,
    height: 50,
  },
  signatureText: {
    width: "100%",
    borderTopWidth: 1,
    borderTopColor: COLORS.light,
    borderTopStyle: "solid",
    textAlign: "center"
  },
  signatureValue: {
    textAlign: "center",
    marginBottom: 5,
  },
  signatureImage: {
    maxWidth: "100%",
    width: "auto",
    marginHorizontal: "auto",
  },
  discountSection: {
    marginTop: 10,
    marginLeft: 10, // to remove negative margin of subTitle
  },
  ...printDocumentStylesDiscounts,
  ...printDocumentStylesHomeDepot,
});
